(function () {
  function initCycleCard(mediaEl) {
    var imgs = Array.prototype.slice.call(mediaEl.querySelectorAll('img.js-cycle-img'));
    var cover = mediaEl.querySelector('img.js-media-default');
    if (cover) imgs.unshift(cover);
    if (imgs.length <= 1) return;

    var dotsWrap = mediaEl.querySelector('.js-view-dots');
    var dots = [];
    if (dotsWrap && dotsWrap.children.length === 0) {
      imgs.forEach(function () {
        var d = document.createElement('span');
        dotsWrap.appendChild(d);
      });
    }
    if (dotsWrap) {
      dots = Array.prototype.slice.call(dotsWrap.children);
      if (dots[0]) dots[0].className = 'on';
    }

    var idx = 0;
    var timer = null;

    function show(i) {
      imgs.forEach(function (img, j) {
        img.style.opacity = j === i ? '1' : '0';
        img.style.visibility = j === i ? 'visible' : 'hidden';
      });
      dots.forEach(function (d, j) {
        d.className = j === i ? 'on' : '';
      });
    }

    mediaEl.addEventListener('mouseenter', function () {
      idx = 0;
      timer = setInterval(function () {
        idx = (idx + 1) % imgs.length;
        show(idx);
      }, 900);
    });

    mediaEl.addEventListener('mouseleave', function () {
      clearInterval(timer);
      idx = 0;
      show(0);
    });
  }

  function init() {
    document.querySelectorAll('.js-image-cycle[data-cycle-count]').forEach(initCycleCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
